import React from 'react';
import { notification, Button, Row, Transfer } from 'antd';
import { useQuery } from 'react-query';
import { useTransfer } from '../../../../hooks/useTransfer';
import { MinusSquareOutlined, CheckSquareTwoTone } from '@ant-design/icons';

import {
  createBrokerParFiltering,
  getParameterDetail,
  getParValuesByBroker,
  removeBrokerParFiltering,
  setParvalueDefault,
} from '../../../../services/parametersService';

type MGParListTransferProps = {
  parameter: string;
  mgid: number;
  titleAvailable: string;
  titleAssociated: string;
  tpidbroker: number;
};

const BrokerParlistTransfer = (props: MGParListTransferProps) => {
  const { parameter, mgid, titleAvailable, titleAssociated, tpidbroker } =
    props;
  const { onSelectChange, selectedKeys } = useTransfer();

  const { data: parListByMG, refetch: refetchparListByMG } = useQuery(
    [
      'getParValuesByBroker',
      { mgid: mgid, parcode: parameter, tpidbroker: tpidbroker },
    ],
    () => {
      return getParValuesByBroker({
        mgid: mgid,
        parcode: parameter,
        tpidbroker: tpidbroker,
      }).then((res) => res.list || []);
    },
    {
      enabled: !!parameter && !!mgid,
    }
  );

  const { data: parameterDetail, refetch: refetchParameterDetal } = useQuery(
    ['getParameterDetail', { parcode: parameter }],
    () => {
      return getParameterDetail({ parcode: parameter }).then((res) => res.data);
    },
    {
      enabled: !!parameter && !!mgid,
    }
  );

  const onChange = (
    targetKeys: string[],
    direction: string,
    moveKeys: string[]
  ) => {
    let promises: Array<Promise<any>> = [];
    moveKeys.forEach((parvalue: string) => {
      const param = {
        mgid: mgid,
        parcode: parameter,
        parvalue,
      };
      if (direction === 'left') {
        let parlist = parListByMG?.find(
          (parlist) => parlist.parvalue === parvalue 
        );
        promises.push(
          removeBrokerParFiltering({
            filterid: parlist?.filterid ?? 0,
            tpidbroker: tpidbroker,
          }).then((res) => {
            if (res.code === '200') {
              notification.success({
                message: res.message,
              });
            }
          })
        );
      } else {
        promises.push(
          createBrokerParFiltering({
            request: {
              filterid: 0,
              flagdefault: false,
              mgid: mgid,
              parcode: parameter,
              parvalue: parvalue,
              tpidbroker: tpidbroker,
            },
            tpidbroker: tpidbroker,
          }).then((res) => {
            if (res.code === '200') {
              notification.success({
                message: res.message,
              });
            }
          })
        );
      }
      return parvalue;
    });
    Promise.all(promises).then((response) => {
      refetchParameterDetal();
      refetchparListByMG();
    });
  };

  const setDefault = (value: string) => {
    //message.info(value);

    const req = {
      target: 'COMPANY',
      mgid: mgid,
      parcode: parameter,
      parvalue: value,
      prcode: '',
      offerid: 0,
      userid: 0,
    };

    setParvalueDefault({ req }).then((response) => {
      if (response.code === '200') {
        notification.success({
          message: response.message,
        });
        refetchParameterDetal();
        refetchparListByMG();
      } else {
        notification.error({
          message: response.message,
          description: response.description,
        });
      }
    });
  };

  const renderItem = (item: any) => {
    const ind = parListByMG?.find((elem) => elem.parvalue === item.parvalue);
    const flagdefault = ind?.flagdefault;

    const customLabel = (
      <span className="custom-item">
        {ind && !flagdefault ? (
          <Button
            size="small"
            icon={<MinusSquareOutlined twoToneColor="#eb2f96" />}
            onClick={(e) => setDefault(item.parvalue)}
          ></Button>
        ) : ind && flagdefault ? (
          <Button
            size="small"
            icon={<CheckSquareTwoTone twoToneColor="#52c41a" />}
            onClick={(e) => setDefault(item.parvalue)}
          ></Button>
        ) : null}
        &nbsp;
        {item.parlistlabel} - {item.parvalue}{' '}
      </span>
    );

    return {
      label: customLabel, // for displayed item
      value: item.parlistlabel, // for title and filter matching
    };
  };

  return (
    <div>
      <Row>
        <Transfer
          style={{ width: '100%' }}
          dataSource={parameterDetail?.parLists}
          showSearch
          targetKeys={parListByMG?.map((parList: any) => parList.parvalue)}
          selectedKeys={selectedKeys}
          onSelectChange={onSelectChange}
          //render={(item) => item.parlistlabel}
          render={renderItem}
          titles={[titleAvailable, titleAssociated]}
          rowKey={(record) => record.parvalue}
          onChange={onChange}
          listStyle={{
            width: '100%',
            height: 300,
          }}
        />
      </Row>
    </div>
  );
};

export default BrokerParlistTransfer;
